var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderArrow = function SvgHeaderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "headerArrow_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#headerArrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D242B",
    d: "M12 14.677a.83.83 0 0 1-.633-.256L6.873 9.928a.73.73 0 0 1-.213-.522.7.7 0 0 1 .213-.531.72.72 0 0 1 .527-.218q.31 0 .527.218L12 12.947l4.073-4.073a.72.72 0 0 1 .522-.213.7.7 0 0 1 .532.213q.216.216.217.526a.72.72 0 0 1-.217.527l-4.495 4.495a.83.83 0 0 1-.632.255"
  }))));
};
export default SvgHeaderArrow;